<template>
  <div class="third-bar">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
          </div>
          <div class="card__descr">
            <span class="card__category">{{ item.sub_category.name }}</span>
            <h3 class="card__title limited-text">{{ item.title }}</h3>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }}</span>
            </div>
          </div>
          <div class="card__brief">
            <p v-html="changeFirstLetter(item.brief)"></p>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.third-bar {
  width: 100%;
  height: 100%;
}
.grid {
  width: 90%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1.5vw;

  &__item {
    grid-column: span 3;
  }
  &__item:nth-child(1) {
    background: #8e1541;
  }
  &__item:nth-child(2) {
    background: #59158e;
  }
  &__item:nth-child(3) {
    background: #154d8e;
  }
  &__item:nth-child(4) {
    background: #4a7980;
  }
}

.card {
  height: 100%;
  &__descr {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 1rem 1.5rem;
  }
  &__title {
    margin: 0.5rem 0;
    font-size: 1.2em;
  }
  &__descr {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &__img {
    .img {
      padding-bottom: 62%;
      border-radius: 0px;
      :deep() img {
        border-radius: 0px;
      }
    }
  }
  &__brief {
    display: none;
  }
}
@media screen and (max-width: 992px) {
  .grid {
    grid-template-columns: repeat(6, 1fr);
    gap: 35px;
    &__item {
      grid-column: span 6;
      background: transparent !important;
    }
  }
  .card {
    position: relative;
    width: 100%;
    height: 39vw;
    &__img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
      &::before {
        content: "";
        background: linear-gradient(
          180deg,
          rgba(72, 72, 72, 0) 0%,
          rgba(0, 0, 0, 0.88) 90.85%
        );
        position: absolute;
        bottom: 0;
        left: 0;
        height: 60%;
        width: 100%;
        z-index: 1;
      }
      .img {
        padding-bottom: 0;
      }
    }
    &__descr {
      margin-top: auto;
      height: 100%;
      background: transparent;
      padding: 0.5rem 15vw;
      text-align: left;
      justify-content: flex-end;
      align-items: flex-start;
    }
    .data-news {
      width: 100%;
      text-align: right;
    }
  }
}
@media screen and (max-width: 767px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem 1rem;
    &__item {
      grid-column: span 2;
    }
    &__item:nth-child(1),
    &__item:nth-child(4) {
      .card {
        position: relative;
        .data-news {
          position: absolute;
          top: 0.5rem;
          left: -0.5rem;
        }
      }
    }
    &__item:nth-child(2),
    &__item:nth-child(3) {
      grid-column: span 1;
      .card {
        height: 100%;
        &__img {
          order: 1;
        }
        &__descr {
          order: 2;
          justify-content: space-between;
        }
        &__title {
          font-size: 0.88em !important;
        }
        &__brief {
          display: none;
        }
      }
    }
  }
  .card {
    height: auto;
    display: flex;
    flex-direction: column;
    &__img {
      order: 2;
      position: relative;
      .img {
        padding-bottom: 66%;
      }
    }
    &__descr {
      order: 1;
      padding: 0.5rem;
      background: linear-gradient(
        102.96deg,
        #1a3770 13.8%,
        rgba(74, 26, 112, 0.58) 99.01%
      );
    }
    &__brief {
      padding: 1rem 0.5rem;

      background: linear-gradient(
        102.96deg,
        #1a3770 13.8%,
        rgba(74, 26, 112, 0.58) 99.01%
      );
      display: block;
      order: 3;
    }
  }
}
</style>
